module.exports = " <div> <div class=col-md-12> <div clas=form-group v-show=show_selector> <label>Seleccione el campeonato a configurar</label> <select v-model=id class=form-control @change=selectChampionship> <option></option> <option v-for=\"championship in championships\" value={{championship.id}}> {{championship.name | capitalize}} </option> </select> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/vue-html-loader!/home/onlygamescl/onlygames-front/shared/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/ChampionshipSelector.vue
 ** module id = 304
 ** module chunks = 1
 **/